export enum KompassifyTemplateVariable {
  FIRST_NAME = 'FIRST_NAME',
  EMPLOYER_NAME = 'EMPLOYER_NAME',
}
